import styled from 'styled-components';

export const LoaderDiv = styled.div`
  position: absolute;
  z-index: 110;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.7);
`;
